var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-pagination"},[(!_vm.first)?_c('button',{staticClass:"popup-pagination__prev",on:{"click":function($event){return _vm.$emit('prev')}}}):_vm._e(),(!_vm.last)?_c('button',{staticClass:"popup-pagination__next",on:{"click":function($event){return _vm.$emit('next')}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }